"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export const VerticalMediamImageDescNews = t0 => {
  const $ = _c(50);
  const {
    title: t1,
    excerpt: t2,
    timeAgo: t3,
    imageSrc: t4,
    slug,
    priority: t5,
    imageMetadata
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "\u0B95\u0BC7.\u0B8E\u0BB2\u0BCD.\u0BB0\u0BBE\u0B95\u0BC1\u0BB2\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BB5\u0BC6\u0BB1\u0BCD\u0BB1\u0BBF\u0B95\u0BB0\u0BAE\u0BBE\u0BA9 \u0B85\u0BB1\u0BC1\u0BB5\u0BC8 \u0B9A\u0BBF\u0B95\u0BBF\u0B9A\u0BCD\u0B9A\u0BC8 \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1, \u0B85\u0BB5\u0BB0\u0BCD \u0BA4\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BBF \u0BB5\u0BB0\u0BC1\u0BB5\u0BA4\u0BBF\u0BB2\u0BCD \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAF\u0BBE\u0B95",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const title = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "\u0BA4\u0BBE\u0BB0\u0B95\u0BCD \u0BAE\u0BC7\u0BA4\u0BCD\u0BA4\u0BBE \u0B95\u0BBE \u0B8A\u0BB2\u0BCD\u0BA4\u0BBE \u0B9A\u0BBE\u0BB7\u0BCD\u0BAE\u0BBE \u0BAA\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BA9\u0BCD \u0BA4\u0BAF\u0BBE\u0BB0\u0BBF\u0BAA\u0BCD\u0BAA\u0BBE\u0BB3\u0BB0\u0BCD \u0B85\u0B9A\u0BBF\u0BA4\u0BCD \u0B95\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD \u0BAE\u0BCB\u0B9F\u0BBF \u0B9A\u0BAE\u0BC0\u0BAA \u0B95\u0BBE\u0BB2\u0BAE\u0BBE\u0B95 \u0BAA\u0BB2 \u0B95\u0BC1\u0BB1\u0BCD\u0BB1\u0B9A\u0BCD\u0B9A\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC8 \u0B9A\u0BA8\u0BCD\u0BA4\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 \u0BB5\u0BB0\u0BC1\u0B95\u0BBF\u0BB1\u0BBE\u0BB0\u0BCD. \u0B9C\u0BC6\u0BA9\u0BBF\u0BAA\u0BB0\u0BCD \u0BAE\u0BBF\u0BB8\u0BCD\u0BA4\u0BBF\u0BB0\u0BBF",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const excerpt = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "May 17, 2023",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const timeAgo = t8;
  let t9;
  if ($[6] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const imageSrc = t9;
  const priority = t5 === undefined ? false : t5;
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  const t10 = timeAgo?.value;
  let t11;
  if ($[8] !== t10) {
    t11 = getTimeAgo(t10);
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const timeAgoValue = t11;
  let t12;
  if ($[10] !== imageSrc?.value) {
    t12 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[10] = imageSrc?.value;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const imageSrcValue = t12;
  let t13;
  if ($[12] !== imageMetadata || $[13] !== imageSrc?.customClass || $[14] !== imageSrc?.hidden || $[15] !== imageSrcValue || $[16] !== priority || $[17] !== titleValue) {
    t13 = !imageSrc?.hidden && <div><div className="relative w-full aspect-[16/9] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`} style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[12] = imageMetadata;
    $[13] = imageSrc?.customClass;
    $[14] = imageSrc?.hidden;
    $[15] = imageSrcValue;
    $[16] = priority;
    $[17] = titleValue;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== title?.customClass || $[20] !== title?.hidden || $[21] !== titleValue) {
    t14 = !title?.hidden && <h3 className={`text-16-tamil-700 leading-[1.4] text-1B1B1B h-auto ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[19] = title?.customClass;
    $[20] = title?.hidden;
    $[21] = titleValue;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== excerpt?.customClass || $[24] !== excerpt?.hidden || $[25] !== excerptValue) {
    t15 = !excerpt?.hidden && <p className={`text-12-tamil-400 text-4D4D4D leading-relaxed line-clamp-4 h-auto ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[23] = excerpt?.customClass;
    $[24] = excerpt?.hidden;
    $[25] = excerptValue;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== timeAgo?.customClass || $[28] !== timeAgo?.hidden || $[29] !== timeAgoValue) {
    t16 = !timeAgo?.hidden && <span className={`text-12-tamil-500 ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[27] = timeAgo?.customClass;
    $[28] = timeAgo?.hidden;
    $[29] = timeAgoValue;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = slug ? `/${slug}` : undefined;
  let t18;
  if ($[31] !== excerptValue || $[32] !== imageSrcValue || $[33] !== slug || $[34] !== t17 || $[35] !== titleValue) {
    t18 = <div className="flex gap-3"><MessageIcon id="message-icon-3" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t17} /></div>;
    $[31] = excerptValue;
    $[32] = imageSrcValue;
    $[33] = slug;
    $[34] = t17;
    $[35] = titleValue;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16 || $[38] !== t18) {
    t19 = <div className="flex justify-between items-center gap-3">{t16}{t18}</div>;
    $[37] = t16;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t14 || $[41] !== t15 || $[42] !== t19) {
    t20 = <div className="flex flex-col gap-3">{t14}{t15}{t19}</div>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t13 || $[45] !== t20) {
    t21 = <div className="flex flex-col bg-F8F8F8 overflow-hidden p-4 gap-4">{t13}{t20}</div>;
    $[44] = t13;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  const content = t21;
  if (slug) {
    const t22 = `/${slug}`;
    let t23;
    if ($[47] !== content || $[48] !== t22) {
      t23 = <Link href={t22} className="block hover:bg-gray-100 transition-colors cursor-pointer">{content}</Link>;
      $[47] = content;
      $[48] = t22;
      $[49] = t23;
    } else {
      t23 = $[49];
    }
    return t23;
  }
  return content;
};